<template>
  <div id="app">
    <e-dialog :dialogVisible="equipmentDialogVisible" @change-state="changeDialogState" :dTitle="dialogTitle" :product="machine"></e-dialog>
    <p-dialog :dialogVisible="processdialogVisible" @change-state="changeDialogState" :machine="machine"></p-dialog>
    <s-dialog :dialogVisible="selectDialogVisible" :category="category" @change-state="changeDialogState"></s-dialog>
    <coupon-dialog :dialogVisible="selectCouponDialogVisible" @change-state="changeDialogState"></coupon-dialog>
    <operation-dialog :dialogVisible="operationDialogVisible" @change-state="changeDialogState" :dTitle="dialogTitle" :alertType="alertType"></operation-dialog>
    <c-dialog :dialogVisible="codesDialogVisible" @change-state="changeDialogState" :batch="machine"></c-dialog>
    <el-container style="height: 100%">
      <el-aside width="220px">
        <el-menu
          :default-active="$route.path"
          router
          background-color="#303f54"
          text-color="#fff"
          :collapse="isCollapse"
          class="menu">
          <!-- <el-menu-item index="/Instrument/Statistics">
            <i class="el-icon-s-data"></i>
            <span slot="title">统计视图</span>
          </el-menu-item> -->
          <el-submenu index="/Instrument">
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span>日常管理</span>
            </template>

            <el-menu-item index="/Instrument/Addition">
              <i class="el-icon-document-add"></i>
              <span slot="title">新增商品</span>
            </el-menu-item>
            <el-menu-item index="/Instrument/Product">
              <i class="el-icon-goods"></i>
              <span slot="title">商品管理</span>
            </el-menu-item>

            <el-menu-item index="/Instrument/Orders">
              <i class="el-icon-document"></i>
              <span slot="title">订单管理</span>
            </el-menu-item>
            <el-menu-item index="/Instrument/Decoration">
              <i class="el-icon-s-shop"></i>
              <span slot="title">商城装修</span>
            </el-menu-item>

            <el-menu-item index="/Instrument/GenerateCode">
              <i class="el-icon-document-checked"></i>
              <span slot="title">生成兑换码</span>
            </el-menu-item>

            <el-menu-item index="/Instrument/GenerateCoupon">
              <i class="el-icon-s-ticket"></i>
              <span slot="title">生成优惠券</span>
            </el-menu-item>

            <el-menu-item index="/Instrument/GenerateUri">
              <i class="el-icon-paperclip"></i>
              <span slot="title">创建NFC链接</span>
            </el-menu-item>
            <el-menu-item index="/Instrument/Refund">
              <i class="el-icon-edit"></i>
              <span slot="title">退款申请</span>
            </el-menu-item>
          </el-submenu>

<!--          <el-submenu index="/Search">-->
<!--            <template slot="title">-->
<!--              <i class="el-icon-search"></i>-->
<!--              <span>查询</span>-->
<!--            </template>-->

<!--            <el-menu-item index="/Instrument/Product">-->
<!--              <i class="el-icon-refresh"></i>-->
<!--              <span slot="title">自定义查询</span>-->
<!--            </el-menu-item>-->
<!--          </el-submenu>-->

          <!-- <el-submenu index="/Files">
            <template slot="title">
              <i class="el-icon-receiving"></i>
              <span>文件工具</span>
            </template>

            <el-menu-item index="/Instrument/Inputs">
              <i class="el-icon-upload2"></i>
              <span slot="title">批量导入</span>
            </el-menu-item>
            <el-menu-item index="/Instrument/Outputs">
              <i class="el-icon-download"></i>
              <span slot="title">数据导出</span>
            </el-menu-item>
          </el-submenu> -->
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="header">
          <div>索妮达管理平台</div>
          <div style="margin-right: 10px;display: flex;justify-content: center;align-content: center">
            <el-button type="text" style="color:#fcfcfc;font-size: 16px" size="small" >{{userName}}</el-button>
            <!-- <el-button @click="refreshUsers" type="text" style="color:#fcfcfc" size="small" >用户同步</el-button> -->
            <el-button @click="logout" type="text"  style="color:#fcfcfc" size="small">退出登录</el-button>
          </div>
        </el-header>
        <el-main style="padding: 15px 20px">
          <el-row>
            <router-view/>
          </el-row>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import equipmentAccountDialog from "@/components/dialog/EquipmentAccountDialog.vue";
import processDialog from '@/components/dialog/ProcessDialog';
import selectEquipmentDialog from '@/components/dialog/SelectEquipmentDialog';
import operationDialog from "@/components/dialog/OperationDialog.vue";
import codesDialog from "@/components/dialog/CodesDialog.vue";
import selectCouponDialog from "@/components/dialog/selectCouponDialog.vue";
export default {
  name: 'equipments',
  components: {
    'e-dialog': equipmentAccountDialog,
    'p-dialog': processDialog,
    's-dialog': selectEquipmentDialog,
    'operation-dialog': operationDialog,
    'c-dialog': codesDialog,
    'coupon-dialog': selectCouponDialog
  },
  data() {
    return {
      departMentId: null,
      machineNO: '',
      userType: 1,
      isCollapse: false,

      equipmentDialogVisible: false,
      processdialogVisible: false,
      selectDialogVisible: false,
      selectCouponDialogVisible: false,
      operationDialogVisible:false,
      codesDialogVisible: false,

      alertType: 'verifyAlert',
      machine: {},
      dialogTitle: '',
      preData: '',
      userName: 'admin',
      alertCount: 0,
      childrenObject: null,
      updateAction: this.$equipmentdata.pre_url + "/importMachines",

      selectIndex: 0,
      isArraySelect: false,
      isGoodsSelect: false,

      selectCouponIndex: 0,

      category: '',
    }
  },
  mounted(){
    //this.userName = localStorage.getItem('name');
    //this.userType = localStorage.getItem('userType');
    //this.getAlertCount();
  },
  methods: {
    changePassword(){

    },
    logout(){
      localStorage.setItem('token','');
      this.$router.push('/login');
    },
    openEditDialog(data,type){
      this.dialogTitle = "修改密码"
      this.preData = localStorage.getItem('userId');
      if(this.preData !== null && this.preData !== undefined){
        this.keyDialogVisible = true;
      }
    },

    async getAlertCount(){
      let r = await this.$equipmentdata.getAlertCount(JSON.stringify(['verifyAlert','borrowAdminAlert','auditCount']));
      console.log(r);
      this.alertCount = r.verifyAlert;
    },

    changeDialogState(val){
      if(val.dialog === 'account'){
        this.equipmentDialogVisible = val.isShow;
        if(!val.isShow) this.machine = {};
        if(val.refresh) {
          this.childrenObject && this.childrenObject.refreshData((alertCount) => {
            this.alertCount = alertCount
          });
        }
      }else if(val.dialog === 'refund'){
        this.processdialogVisible = val.isShow;
        if(val.refresh) {
          console.log(this.childrenObject)
          this.childrenObject && this.childrenObject.refreshData();
        }
      }else if(val.dialog === 'select'){
        this.selectDialogVisible = val.isShow;

        if(this.isArraySelect){
          this.isArraySelect = false;
          if(this.childrenObject && val.data){
            this.childrenObject.$set(this.childrenObject.config['config'].mediaUrls[this.selectIndex], 'productId', val.data._id);
            this.childrenObject.$set(this.childrenObject.config['config'].mediaUrls[this.selectIndex], 'productName', val.data.name);
          }
        }else if(this.isGoodsSelect){
          this.isGoodsSelect = false;
          if(this.childrenObject){
            //console.log(val.data)
            const tempGoods = this.childrenObject.goodList;
            tempGoods[this.childrenObject.activeGoodIndex].tabData.push({productInfo: val.data});
            //this.childrenObject.$set(this.childrenObject.localConfig.config, 'goods', tempGoods);
          }
        }else{
          this.childrenObject && this.childrenObject.$set(this.childrenObject,'product' , val.data);
        }
      }else if(val.dialog === 'coupon'){
        this.selectCouponDialogVisible = val.isShow;
        if(this.childrenObject){
          const tempCouponList = this.childrenObject.couponList;
          tempCouponList[this.selectCouponIndex].couponInfo = val.data;
          this.childrenObject.$set(this.childrenObject, 'couponList', []);
          this.childrenObject.$set(this.childrenObject, 'couponList', tempCouponList);
        }
      }else if(val.dialog === 'operation'){
        this.operationDialogVisible = val.isShow
      }else if(val.dialog === 'codes'){
        this.codesDialogVisible = val.isShow
      }
    },

    openDialog(data,type){
      if(type === 'alert'){
        this.alertDialogVisible = true;
      }
    },

    async refreshUsers(){
      //let result = await this.$requiredata.getAllUsers();
      //let result = await this.$requiredata.sendNotice();
      let result = await this.$equipmentdata.updateUsersPhone();
      console.log(result);
      // result.userList.forEach( (user,index) => {
      //   let temp = {
      //     name: user.name,
      //     departmentId: user.main_department,
      //     password: '123456',
      //     userType: '4'
      //   }
      //   users.push(temp);
      // })
      // let res = await this.$equipmentdata.insertUsers(users);
      // console.log(res);
    },
  }
}
</script>

<style>
html,body{
  margin: 0;
  height: 100%;
}
.header-nav{
  height: 35px;
  background-color: #EEF2F5;
  text-align: left;
  display: flex;
  align-items: center;
  padding: 10px;
  color: #666;
  font-size: 14px;
}
.header{
  height: 60px;
  background-color: #427AB3;
  color: #fff;
  text-align: left;
  padding: 10px;
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 22px;
  justify-content: space-between;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  width:100%;
}
.content{
  height: 100%;
}
.menu{
  height: 100%;
}
body .el-table th.gutter{
display: table-cell!important;
}

.selection{
  text-align: left;
}
.is-scrolling-none{
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/instrument.vue